import React, { FC } from 'react'
import { FieldProps } from 'formik'
import { Radio } from 'antd'

const RadioGroup: FC<FieldProps> = props => {
  const { field } = props

  // @ts-ignore
  const { children } = props
  return (
    <Radio.Group
      value={field.value}
      onChange={field.onChange}
      name={field.name}
    >
      {children}
    </Radio.Group>
  )
}

export default RadioGroup
